module.exports = __webpack_public_path__ + "static/team@2x-8c54040f4025462f65d38922c675568f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/enterprise/team@2x.jpg
// module id = 2575
// module chunks = 168707334958949